import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";

import { cn } from "@/lib/utils";
import { CheckIcon } from "lucide-react";
import { useRef } from "react";

function Checkbox({
  className,
  onCheckedChange,
  ...props
}: CheckboxPrimitive.Root.Props) {
  const rootRef = useRef<HTMLButtonElement>(null);

  const handleCheckedChange: typeof onCheckedChange = (checked, event) => {
    if (checked && typeof rootRef.current?.animate === "function") {
      rootRef.current.animate(
        [
          { transform: "scale(1)" },
          { transform: "scale(1.3)" },
          { transform: "scale(0.9)" },
          { transform: "scale(1)" },
        ],
        { duration: 300, easing: "ease-out" },
      );
    }
    onCheckedChange?.(checked, event);
  };

  return (
    <CheckboxPrimitive.Root
      ref={rootRef}
      data-slot="checkbox"
      onCheckedChange={handleCheckedChange}
      className={cn(
        "peer relative flex size-6 shrink-0 items-center justify-center rounded-md border border-input transition-colors outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none [&>svg]:size-5"
      >
        <CheckIcon />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
